import { render, staticRenderFns } from "./SplitPanelA.vue?vue&type=template&id=6cd40b1a&scoped=true"
import script from "./SplitPanelA.vue?vue&type=script&lang=js"
export * from "./SplitPanelA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd40b1a",
  null
  
)

export default component.exports